var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 19.5a.97.97 0 0 1-.712-.286.96.96 0 0 1-.288-.71.96.96 0 0 1 .288-.709A.97.97 0 0 1 3 17.51h4.75a8.1 8.1 0 0 0-1.4-2.838A8 8 0 0 0 4 12.606q-.55-.324-.525-.71t.675-.36q3.274.049 5.563 2.364Q12 16.215 12 19.5zm11 0q0-1.046-.225-2.078a10 10 0 0 0-.65-1.979 8.3 8.3 0 0 1 2.813-2.788q1.763-1.07 3.912-1.12.6-.024.625.386t-.475.685q-1.375.796-2.35 2.065a8.1 8.1 0 0 0-1.4 2.838H21a.97.97 0 0 1 .712.286.96.96 0 0 1 .288.71.96.96 0 0 1-.288.709.97.97 0 0 1-.712.286zm-2-5.949q0-2.637 1.512-4.691 1.514-2.055 3.888-2.85.575-.199.85.124.274.324-.225.797a8.6 8.6 0 0 0-1.387 1.667q-.588.921-.988 1.967a9.5 9.5 0 0 0-2.013 1.281A10.6 10.6 0 0 0 12 13.551m-1.825-1.866q-.3-.224-.6-.424-.3-.198-.625-.398 0-.15.025-.31Q9 10.39 9 10.24q0-1.32-.287-2.514a11.2 11.2 0 0 0-.838-2.315q-.274-.547.037-.808.313-.263.813.136.9.723 1.588 1.643.687.921 1.112 2.016a10.3 10.3 0 0 0-.775 1.58 8.8 8.8 0 0 0-.475 1.706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.5d1defffc11daa52b19b0518278def71.svg";
export { ForwardRef as ReactComponent };